import React, { useState } from 'react';
import EnhancedSEO from '../../Components/SEO/EnhancedSEO';


const CookiePolicyPage = () => {
  const [expandedSection, setExpandedSection] = useState('overview');
  const [showSection, setShowSection] = useState(false); // Flag to control team section visibility
  

  const handleAccordionToggle = (sectionId) => {
    setExpandedSection(expandedSection === sectionId ? null : sectionId);
  };

  const containerStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '32px 16px',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    lineHeight: 1.5,
    color: '#212121'
  };

  const headerStyle = {
    background: 'linear-gradient(135deg, #ff9800 0%, #f57c00 100%)',
    color: 'white',
    padding: '32px',
    borderRadius: '8px',
    marginBottom: '32px',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
  };

  const paperStyle = {
    backgroundColor: '#fff',
    padding: '16px',
    borderRadius: '8px',
    border: '1px solid #e0e0e0',
    marginBottom: '16px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
  };

  const accordionStyle = {
    backgroundColor: '#fff',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    marginBottom: '8px',
    overflow: 'hidden'
  };

  const accordionHeaderStyle = {
    padding: '16px',
    cursor: 'pointer',
    backgroundColor: '#f5f5f5',
    borderBottom: '1px solid #e0e0e0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    transition: 'background-color 0.2s'
  };

  const accordionContentStyle = {
    padding: '24px',
    borderTop: '1px solid #e0e0e0'
  };

  const chipStyle = {
    display: 'inline-block',
    padding: '6px 12px',
    margin: '4px',
    borderRadius: '16px',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'all 0.2s'
  };

  const cardStyle = {
    backgroundColor: '#f5f5f5',
    padding: '16px',
    borderRadius: '8px',
    marginBottom: '16px',
    border: '1px solid #e0e0e0'
  };

  const alertStyle = {
    padding: '16px',
    borderRadius: '8px',
    marginBottom: '16px',
    border: '1px solid #e3f2fd',
    backgroundColor: '#e3f2fd',
    color: '#1976d2'
  };

  const warningAlertStyle = {
    ...alertStyle,
    border: '1px solid #fff3e0',
    backgroundColor: '#fff3e0',
    color: '#f57c00'
  };

  const successAlertStyle = {
    ...alertStyle,
    border: '1px solid #e8f5e8',
    backgroundColor: '#e8f5e8',
    color: '#388e3c'
  };

  const buttonStyle = {
    padding: '12px 24px',
    borderRadius: '4px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    margin: '4px',
    transition: 'all 0.2s'
  };

  const primaryButtonStyle = {
    ...buttonStyle,
    backgroundColor: '#ff9800',
    color: 'white'
  };

  const outlinedButtonStyle = {
    ...buttonStyle,
    backgroundColor: 'transparent',
    color: '#ff9800',
    border: '1px solid #ff9800'
  };

  const sections = [
    {
      id: 'overview',
      title: 'What Are Cookies?',
      icon: '🍪',
      color: '#ff9800',
      content: (
        <div>
          <p style={{ marginBottom: '16px' }}>
            Cookies are small text files stored on your device when you visit websites. They help us provide you with a better, more personalized experience on Revfer.
          </p>
          
          <div style={alertStyle}>
            <h4 style={{ margin: '0 0 8px 0', fontSize: '16px' }}>
              Your Control Over Cookies
            </h4>
            <p style={{ margin: 0, fontSize: '14px' }}>
              You have choices about how we use cookies. This policy explains what cookies we use, 
              why we use them, and how you can manage your preferences.
            </p>
          </div>

          <h3 style={{ marginTop: '24px', marginBottom: '16px', color: '#ff9800' }}>
            Types of Cookies We Use:
          </h3>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px', marginTop: '16px' }}>
            <div style={{ ...cardStyle, backgroundColor: '#e3f2fd', color: '#1976d2' }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                <span style={{ fontSize: '20px', marginRight: '8px' }}>⚙️</span>
                <h4 style={{ margin: 0 }}>Essential Cookies</h4>
              </div>
              <p style={{ margin: 0, fontSize: '14px' }}>Required for basic website functionality</p>
            </div>
            <div style={{ ...cardStyle, backgroundColor: '#f3e5f5', color: '#7b1fa2' }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                <span style={{ fontSize: '20px', marginRight: '8px' }}>📊</span>
                <h4 style={{ margin: 0 }}>Analytics Cookies</h4>
              </div>
              <p style={{ margin: 0, fontSize: '14px' }}>Help us understand how you use our site</p>
            </div>
            <div style={{ ...cardStyle, backgroundColor: '#e8f5e8', color: '#388e3c' }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                <span style={{ fontSize: '20px', marginRight: '8px' }}>🎯</span>
                <h4 style={{ margin: 0 }}>Functional Cookies</h4>
              </div>
              <p style={{ margin: 0, fontSize: '14px' }}>Remember your preferences and settings</p>
            </div>
            <div style={{ ...cardStyle, backgroundColor: '#fff3e0', color: '#f57c00' }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                <span style={{ fontSize: '20px', marginRight: '8px' }}>🎪</span>
                <h4 style={{ margin: 0 }}>Marketing Cookies</h4>
              </div>
              <p style={{ margin: 0, fontSize: '14px' }}>Deliver relevant content and advertising</p>
            </div>
          </div>

          <div style={warningAlertStyle}>
            <h4 style={{ margin: '0 0 8px 0' }}>
              Last Updated: June 4, 2025
            </h4>
            <p style={{ margin: 0, fontSize: '14px' }}>
              This Cookie Policy is part of our Privacy Policy and Terms of Service. 
              Changes to this policy will be communicated through our standard notification process.
            </p>
          </div>
        </div>
      )
    },
    {
      id: 'essential-cookies',
      title: 'Essential Cookies',
      icon: '⚙️',
      color: '#1976d2',
      content: (
        <div>
          <p style={{ marginBottom: '16px' }}>
            Essential cookies are necessary for our website to function properly. These cannot be disabled as they are critical for basic website operations.
          </p>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#1976d2' }}>Authentication & Security</h4>
            <div style={{ marginBottom: '12px' }}>
              <strong>Cookie Name:</strong> revfer_session, auth_token, csrf_token
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Purpose:</strong> Keep you logged in securely and protect against security threats
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Duration:</strong> Session cookies (deleted when you close browser) or 30 days for "Remember Me"
            </div>
            <p style={{ margin: 0, fontSize: '14px' }}>
              These cookies authenticate your identity, maintain your login state, and protect against 
              cross-site request forgery attacks.
            </p>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#7b1fa2' }}>Platform Functionality</h4>
            <div style={{ marginBottom: '12px' }}>
              <strong>Cookie Name:</strong> revfer_settings, ui_state, location_consent
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Purpose:</strong> Remember your settings and preferences during your visit
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Duration:</strong> Session to 1 year depending on setting type
            </div>
            <p style={{ margin: 0, fontSize: '14px' }}>
              These cookies store your language preference, UI customizations, consent choices, 
              and temporary data needed for features like search filters.
            </p>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#388e3c' }}>Load Balancing & Performance</h4>
            <div style={{ marginBottom: '12px' }}>
              <strong>Cookie Name:</strong> aws_server, cdn_region
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Purpose:</strong> Route your requests to the optimal server for best performance
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Duration:</strong> Session cookies
            </div>
            <p style={{ margin: 0, fontSize: '14px' }}>
              These technical cookies ensure you're connected to the closest server for faster loading 
              and consistent experience across our distributed infrastructure.
            </p>
          </div>

          <div style={successAlertStyle}>
            <h4 style={{ margin: '0 0 8px 0' }}>
              Why Essential Cookies Can't Be Disabled
            </h4>
            <p style={{ margin: 0, fontSize: '14px' }}>
              Essential cookies are fundamental to website security and basic functionality. 
              Disabling them would prevent you from logging in, maintaining sessions, or using core features safely.
            </p>
          </div>
        </div>
      )
    },
    {
      id: 'analytics-cookies',
      title: 'Analytics & Performance Cookies',
      icon: '📊',
      color: '#7b1fa2',
      content: (
        <div>
          <p style={{ marginBottom: '16px' }}>
            Analytics cookies help us understand how users interact with our platform so we can improve performance and user experience.
          </p>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#1976d2' }}>Usage Analytics</h4>
            <div style={{ marginBottom: '12px' }}>
              <strong>Provider:</strong> Google Analytics, Internal Analytics
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Cookie Names:</strong> _ga, _ga_*, _gid, revfer_analytics
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Purpose:</strong> Track page views, user journeys, and feature usage
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Duration:</strong> 1 day to 2 years
            </div>
            <p style={{ margin: 0, fontSize: '14px' }}>
              These cookies help us understand which features are most popular, where users encounter 
              difficulties, and how we can improve the overall experience.
            </p>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#7b1fa2' }}>Performance Monitoring</h4>
            <div style={{ marginBottom: '12px' }}>
              <strong>Provider:</strong> AWS CloudWatch, Internal Monitoring
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Cookie Names:</strong> perf_monitor, error_tracking
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Purpose:</strong> Monitor site performance, loading times, and technical errors
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Duration:</strong> Session to 30 days
            </div>
            <p style={{ margin: 0, fontSize: '14px' }}>
              Performance cookies help us identify slow-loading pages, technical issues, and opportunities 
              to optimize the platform for better speed and reliability.
            </p>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#388e3c' }}>A/B Testing & Optimization</h4>
            <div style={{ marginBottom: '12px' }}>
              <strong>Provider:</strong> Internal Testing Platform
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Cookie Names:</strong> ab_test_group, feature_flag
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Purpose:</strong> Serve different versions of features to test improvements
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Duration:</strong> 30 to 90 days
            </div>
            <p style={{ margin: 0, fontSize: '14px' }}>
              These cookies ensure you have a consistent experience during tests and help us measure 
              which versions of features work best for our users.
            </p>
          </div>

          <div style={warningAlertStyle}>
            <h4 style={{ margin: '0 0 8px 0' }}>
              Analytics Data Privacy
            </h4>
            <p style={{ margin: 0, fontSize: '14px' }}>
              Analytics data is anonymized and aggregated. We don't use this data to identify individual users 
              or for purposes beyond platform improvement. You can opt out of analytics cookies in your preferences.
            </p>
          </div>
        </div>
      )
    },
    {
      id: 'functional-cookies',
      title: 'Functional & Preference Cookies',
      icon: '🎯',
      color: '#388e3c',
      content: (
        <div>
          <p style={{ marginBottom: '16px' }}>
            Functional cookies remember your choices and provide enhanced, personalized features to improve your experience.
          </p>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#1976d2' }}>Personalization & Preferences</h4>
            <div style={{ marginBottom: '12px' }}>
              <strong>Cookie Names:</strong> user_prefs, display_settings, search_filters
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Purpose:</strong> Remember your preferred settings and customizations
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Duration:</strong> 6 months to 1 year
            </div>
            <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '14px' }}>
              <li>Language and region preferences</li>
              <li>Display name and profile visibility settings</li>
              <li>Search filters and business category preferences</li>
              <li>Review sorting and display preferences</li>
              <li>Map view and location sharing settings</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#7b1fa2' }}>AI & Recommendation Features</h4>
            <div style={{ marginBottom: '12px' }}>
              <strong>Cookie Names:</strong> ai_prefs, recommendation_state
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Purpose:</strong> Optimize AI-assisted features and recommendations for you
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Duration:</strong> 3 to 12 months
            </div>
            <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '14px' }}>
              <li>AI review assistance preferences and usage patterns</li>
              <li>Business recommendation algorithm tuning</li>
              <li>Personalized "For You" content curation</li>
              <li>Smart rating system participation settings</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#388e3c' }}>Social & Network Features</h4>
            <div style={{ marginBottom: '12px' }}>
              <strong>Cookie Names:</strong> network_state, social_prefs, trust_settings
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Purpose:</strong> Enhance trust network and social features
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Duration:</strong> 6 months to 1 year
            </div>
            <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '14px' }}>
              <li>Trust network visibility and connection preferences</li>
              <li>Business following and notification settings</li>
              <li>Community verification participation preferences</li>
              <li>Social sharing and privacy controls</li>
            </ul>
          </div>

          <div style={alertStyle}>
            <h4 style={{ margin: '0 0 8px 0' }}>
              Functional Cookie Benefits
            </h4>
            <p style={{ margin: 0, fontSize: '14px' }}>
              These cookies significantly improve your experience by remembering your preferences. 
              While not essential, disabling them means you'll need to reset your preferences each visit.
            </p>
          </div>
        </div>
      )
    },
    {
      id: 'marketing-cookies',
      title: 'Marketing & Advertising Cookies',
      icon: '🎪',
      color: '#f57c00',
      content: (
        <div>
          <p style={{ marginBottom: '16px' }}>
            Marketing cookies help us show you relevant content and advertisements, both on our platform and on other websites.
          </p>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#1976d2' }}>Targeted Content & Recommendations</h4>
            <div style={{ marginBottom: '12px' }}>
              <strong>Cookie Names:</strong> content_targeting, business_interests
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Purpose:</strong> Show relevant businesses and content based on your interests
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Duration:</strong> 30 days to 1 year
            </div>
            <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '14px' }}>
              <li>Personalized business recommendations in your feed</li>
              <li>Relevant trending businesses in your area</li>
              <li>Targeted content in newsletters and notifications</li>
              <li>Customized onboarding and feature introductions</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#7b1fa2' }}>Third-Party Advertising</h4>
            <div style={{ marginBottom: '12px' }}>
              <strong>Providers:</strong> Google Ads, Facebook Pixel, LinkedIn Insight
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Cookie Names:</strong> _fbp, _fbc, li_sugr, google_ads_*
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Purpose:</strong> Show relevant Revfer ads when you visit other websites
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Duration:</strong> 90 days to 2 years (set by third parties)
            </div>
            <p style={{ margin: 0, fontSize: '14px' }}>
              These cookies help us show you relevant information about Revfer features or local businesses 
              when you're browsing other websites, rather than showing random advertisements.
            </p>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#388e3c' }}>Campaign Tracking & Attribution</h4>
            <div style={{ marginBottom: '12px' }}>
              <strong>Cookie Names:</strong> utm_source, campaign_id, referral_tracking
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Purpose:</strong> Understand how you discovered Revfer and measure campaign effectiveness
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Duration:</strong> 30 to 180 days
            </div>
            <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '14px' }}>
              <li>Track which marketing campaigns bring new users</li>
              <li>Measure effectiveness of different advertising channels</li>
              <li>Understand user journey from discovery to signup</li>
              <li>Optimize marketing spend and messaging</li>
            </ul>
          </div>

          <div style={warningAlertStyle}>
            <h4 style={{ margin: '0 0 8px 0' }}>
              Marketing Cookie Control
            </h4>
            <p style={{ margin: 0, fontSize: '14px' }}>
              You can disable marketing cookies without affecting core platform functionality. 
              This may result in less relevant advertisements and recommendations, but won't impact your ability to use Revfer.
            </p>
          </div>
        </div>
      )
    },
    {
      id: 'third-party',
      title: 'Third-Party Cookies & Services',
      icon: '🔗',
      color: '#e65100',
      content: (
        <div>
          <p style={{ marginBottom: '16px' }}>
            Some features on Revfer use third-party services that may set their own cookies. Here's what you should know:
          </p>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#1976d2' }}>AI & Processing Services</h4>
            <div style={{ marginBottom: '12px' }}>
              <strong>Provider:</strong> OpenAI
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Purpose:</strong> AI-assisted review writing and content processing
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Data Handling:</strong> Temporary processing only, no long-term storage
            </div>
            <p style={{ margin: 0, fontSize: '14px' }}>
              When you use AI assistance features, your content may be processed by OpenAI's systems. 
              They may use technical cookies for their service but don't retain your personal data.
            </p>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#7b1fa2' }}>Analytics & Monitoring</h4>
            <div style={{ marginBottom: '12px' }}>
              <strong>Providers:</strong> Google Analytics, AWS CloudWatch
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Purpose:</strong> Website analytics and performance monitoring
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Data Handling:</strong> Anonymized analytics data
            </div>
            <p style={{ margin: 0, fontSize: '14px' }}>
              These services help us understand site usage patterns and technical performance. 
              Data is aggregated and anonymized according to their privacy policies.
            </p>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#388e3c' }}>Payment Processing</h4>
            <div style={{ marginBottom: '12px' }}>
              <strong>Providers:</strong> Stripe, PayPal
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Purpose:</strong> Secure payment processing for premium features
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Data Handling:</strong> PCI-compliant secure payment data handling
            </div>
            <p style={{ margin: 0, fontSize: '14px' }}>
              Payment processors use cookies for fraud detection and secure transaction processing. 
              They follow strict financial data protection standards.
            </p>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#f57c00' }}>Social Media Integration</h4>
            <div style={{ marginBottom: '12px' }}>
              <strong>Providers:</strong> Facebook, Google, LinkedIn
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Purpose:</strong> Social login and sharing features
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Data Handling:</strong> According to each provider's privacy policy
            </div>
            <p style={{ margin: 0, fontSize: '14px' }}>
              When you use social login or sharing features, these platforms may set tracking cookies. 
              You can manage these through your social media account settings.
            </p>
          </div>

          <div style={alertStyle}>
            <h4 style={{ margin: '0 0 8px 0' }}>
              Third-Party Cookie Control
            </h4>
            <p style={{ margin: 0, fontSize: '14px' }}>
              Third-party cookies are governed by each provider's privacy policy. 
              You can control many of these through browser settings or by visiting each provider's opt-out pages.
            </p>
          </div>
        </div>
      )
    },
    {
      id: 'manage-cookies',
      title: 'Managing Your Cookie Preferences',
      icon: '⚙️',
      color: '#0288d1',
      content: (
        <div>
          <p style={{ marginBottom: '16px' }}>
            You have several options for controlling how cookies are used on your device:
          </p>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#1976d2' }}>Revfer Cookie Settings</h4>
            <p style={{ marginBottom: '12px', fontSize: '14px' }}>
              Manage your cookie preferences directly in your Revfer account:
            </p>
            <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '14px' }}>
              <li>Go to Account Settings → Privacy & Data → Cookie Preferences</li>
              <li>Toggle different cookie categories on/off (except essential cookies)</li>
              <li>Choose granular controls for analytics and marketing features</li>
              <li>Export your cookie preference settings</li>
              <li>Reset all non-essential cookies with one click</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#7b1fa2' }}>Browser Cookie Controls</h4>
            <p style={{ marginBottom: '12px', fontSize: '14px' }}>
              Most browsers allow you to control cookies through their settings:
            </p>
            <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '14px' }}>
              <li><strong>Chrome:</strong> Settings → Privacy and security → Site Settings → Cookies</li>
              <li><strong>Firefox:</strong> Preferences → Privacy & Security → Cookies and Site Data</li>
              <li><strong>Safari:</strong> Preferences → Privacy → Manage Website Data</li>
              <li><strong>Edge:</strong> Settings → Site permissions → Cookies and site data</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#388e3c' }}>Third-Party Opt-Outs</h4>
            <p style={{ marginBottom: '12px', fontSize: '14px' }}>
              You can opt out of specific third-party tracking:
            </p>
            <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '14px' }}>
              <li><strong>Google Analytics:</strong> tools.google.com/dlpage/gaoptout</li>
              <li><strong>Facebook:</strong> facebook.com/settings?tab=ads</li>
              <li><strong>LinkedIn:</strong> linkedin.com/psettings/advertising</li>
              <li><strong>Network Advertising Initiative:</strong> optout.networkadvertising.org</li>
              <li><strong>Digital Advertising Alliance:</strong> optout.aboutads.info</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#f57c00' }}>Mobile App Controls</h4>
            <p style={{ marginBottom: '12px', fontSize: '14px' }}>
              Mobile devices have additional privacy controls:
            </p>
            <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '14px' }}>
              <li><strong>iOS:</strong> Settings → Privacy & Security → Tracking → Allow Apps to Request to Track</li>
              <li><strong>Android:</strong> Settings → Privacy → Ads → Opt out of Ads Personalization</li>
              <li>Reset advertising identifiers in your device's privacy settings</li>
              <li>Limit ad tracking through built-in privacy controls</li>
            </ul>
          </div>

          <div style={warningAlertStyle}>
            <h4 style={{ margin: '0 0 8px 0' }}>
              Impact of Disabling Cookies
            </h4>
            <p style={{ margin: 0, fontSize: '14px' }}>
              Disabling cookies may affect platform functionality. Essential cookies cannot be disabled, 
              but you can control analytics, functional, and marketing cookies. Some features may not work as expected.
            </p>
          </div>
        </div>
      )
    },
    {
      id: 'updates-contact',
      title: 'Policy Updates & Contact Information',
      icon: '📞',
      color: '#607d8b',
      content: (
        <div>
          <p style={{ marginBottom: '16px' }}>
            Information about cookie policy updates and how to contact us with questions:
          </p>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#1976d2' }}>Policy Updates</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>We review and update this Cookie Policy periodically</li>
              <li>Material changes are communicated via email and platform notifications</li>
              <li>Current version date is always shown at the top of this policy</li>
              <li>Continued use of Revfer constitutes acceptance of updated policies</li>
              <li>You can review the history of changes in our transparency center</li>
            </ul>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px', marginTop: '16px' }}>
            <div style={{ ...cardStyle, backgroundColor: '#e3f2fd', color: '#1976d2' }}>
              <h4 style={{ marginBottom: '8px' }}>Cookie Questions</h4>
              <p style={{ margin: '0 0 8px 0', fontSize: '14px' }}>
                Email: cookies@revfer.com
              </p>
              <p style={{ margin: '0 0 8px 0', fontSize: '14px' }}>
                Response time: Within 48 hours
              </p>
              <p style={{ margin: 0, fontSize: '14px' }}>
                For questions about our cookie usage and this policy.
              </p>
            </div>
            <div style={{ ...cardStyle, backgroundColor: '#f3e5f5', color: '#7b1fa2' }}>
              <h4 style={{ marginBottom: '8px' }}>Privacy Concerns</h4>
              <p style={{ margin: '0 0 8px 0', fontSize: '14px' }}>
                Email: privacy@revfer.com
              </p>
              <p style={{ margin: '0 0 8px 0', fontSize: '14px' }}>
                Response time: Within 48 hours
              </p>
              <p style={{ margin: 0, fontSize: '14px' }}>
                For broader privacy questions and data protection concerns.
              </p>
            </div>
            <div style={{ ...cardStyle, backgroundColor: '#e8f5e8', color: '#388e3c' }}>
              <h4 style={{ marginBottom: '8px' }}>Technical Support</h4>
              <p style={{ margin: '0 0 8px 0', fontSize: '14px' }}>
                Email: support@revfer.com
              </p>
              <p style={{ margin: '0 0 8px 0', fontSize: '14px' }}>
                Response time: Within 24 hours
              </p>
              <p style={{ margin: 0, fontSize: '14px' }}>
                For help with cookie settings and technical issues.
              </p>
            </div>
            <div style={{ ...cardStyle, backgroundColor: '#fff3e0', color: '#f57c00' }}>
              <h4 style={{ marginBottom: '8px' }}>Data Protection Officer</h4>
              <p style={{ margin: '0 0 8px 0', fontSize: '14px' }}>
                Email: dpo@revfer.com
              </p>
              <p style={{ margin: '0 0 8px 0', fontSize: '14px' }}>
                Response time: Within 72 hours
              </p>
              <p style={{ margin: 0, fontSize: '14px' }}>
                For formal data protection and compliance inquiries.
              </p>
            </div>
          </div>

          <div style={successAlertStyle}>
            <h4 style={{ margin: '0 0 8px 0' }}>
              Regulatory Compliance
            </h4>
            <p style={{ margin: 0, fontSize: '14px' }}>
              This Cookie Policy complies with GDPR, CCPA, and other applicable data protection regulations. 
              We're committed to transparency and giving you control over your data.
            </p>
          </div>
        </div>
      )
    }
  ];

  return (
    <>
      {/* 🚀 COMPREHENSIVE SEO OPTIMIZATION WITH STRUCTURED DATA */}
      <EnhancedSEO 
        title="Cookie Policy - Revfer | How We Use Cookies & Tracking Technologies"
        description="Comprehensive cookie policy for Revfer's AI business discovery platform. Learn how we use essential, analytics, functional, and marketing cookies, manage your cookie preferences, control third-party tracking, and understand cookie privacy settings for our professional networking and business review platform."
        keywords="cookie policy, cookies usage, tracking technologies, cookie preferences, cookie consent, essential cookies, analytics cookies, functional cookies, marketing cookies, third-party cookies, cookie management, browser settings, tracking opt-out, GDPR cookie compliance, cookie privacy, website tracking, cookie types, cookie duration, cookie control, web analytics cookies"
        type="webpage"
        image="/images/revfer-cookie-policy-og.jpg"
        author="Revfer Privacy Team"
        dateModified="2025-06-04T00:00:00Z"
        datePublished="2024-01-15T00:00:00Z"
        breadcrumbs={[
          { name: 'Home', url: '/' },
          { name: 'Legal', url: '/legal' },
          { name: 'Cookie Policy', url: '/legal/cookie-policy' }
        ]}
        organizationData={{
          "@context": "https://schema.org",
          "@type": ["TechnologyCompany", "LegalDocument"],
          "mainEntity": {
            "@type": "CreativeWork",
            "@id": "https://www.revfer.com/legal/cookie-policy",
            "name": "Revfer Cookie Policy",
            "description": "Comprehensive policy explaining how Revfer uses cookies and tracking technologies, including essential, analytics, functional, and marketing cookies with user control options",
            "url": "https://www.revfer.com/legal/cookie-policy",
            "dateModified": "2025-06-04T00:00:00Z",
            "datePublished": "2024-01-15T00:00:00Z",
            "publisher": {
              "@type": "Organization",
              "name": "Revfer Inc",
              "url": "https://www.revfer.com",
              "logo": {
                "@type": "ImageObject",
                "url": "https://www.revfer.com/logo.png"
              }
            },
            "inLanguage": "en-US",
            "copyrightHolder": {
              "@type": "Organization",
              "name": "Revfer Inc"
            },
            "about": [
              {
                "@type": "Thing",
                "name": "Essential Cookies",
                "description": "Cookies required for basic website functionality, authentication, and security"
              },
              {
                "@type": "Thing",
                "name": "Analytics Cookies",
                "description": "Cookies used to understand website usage patterns and performance monitoring"
              },
              {
                "@type": "Thing",
                "name": "Functional Cookies", 
                "description": "Cookies that remember user preferences and provide personalized features"
              },
              {
                "@type": "Thing",
                "name": "Marketing Cookies",
                "description": "Cookies used for targeted content, advertising, and campaign tracking"
              },
              {
                "@type": "Thing",
                "name": "Third-Party Services",
                "description": "How third-party services like OpenAI, Google Analytics, and payment processors use cookies"
              },
              {
                "@type": "Thing",
                "name": "Cookie Management",
                "description": "How users can control and manage their cookie preferences and opt-out options"
              }
            ],
            "mentions": [
              {
                "@type": "SoftwareApplication",
                "name": "Google Analytics",
                "description": "Web analytics service that uses cookies to track website usage"
              },
              {
                "@type": "Organization",
                "name": "OpenAI",
                "description": "AI service provider that may use technical cookies for processing"
              },
              {
                "@type": "SoftwareApplication",
                "name": "AWS CloudWatch", 
                "description": "Performance monitoring service using cookies for tracking"
              },
              {
                "@type": "Legislation",
                "name": "General Data Protection Regulation",
                "alternateName": "GDPR",
                "description": "EU regulation governing cookie consent and user privacy"
              },
              {
                "@type": "Legislation",
                "name": "California Consumer Privacy Act",
                "alternateName": "CCPA",
                "description": "California law governing tracking technologies and user rights"
              }
            ],
            "cookieTypes": [
              {
                "@type": "Thing",
                "name": "Essential Cookies",
                "description": "Authentication, security, and basic functionality cookies that cannot be disabled",
                "duration": "Session to 30 days",
                "purpose": "Website security and basic operations"
              },
              {
                "@type": "Thing",
                "name": "Analytics Cookies",
                "description": "Usage tracking and performance monitoring cookies",
                "duration": "1 day to 2 years", 
                "purpose": "Website improvement and usage analysis",
                "optOut": true
              },
              {
                "@type": "Thing",
                "name": "Functional Cookies",
                "description": "User preference and personalization cookies",
                "duration": "6 months to 1 year",
                "purpose": "Enhanced user experience and personalization",
                "optOut": true
              },
              {
                "@type": "Thing",
                "name": "Marketing Cookies",
                "description": "Advertising and campaign tracking cookies",
                "duration": "30 days to 2 years",
                "purpose": "Relevant advertising and marketing campaigns",
                "optOut": true
              }
            ],
            "thirdPartyServices": [
              {
                "@type": "Thing",
                "name": "Google Analytics",
                "purpose": "Website analytics and performance monitoring",
                "cookieNames": "_ga, _ga_*, _gid",
                "optOut": "https://tools.google.com/dlpage/gaoptout"
              },
              {
                "@type": "Thing",
                "name": "OpenAI",
                "purpose": "AI content processing and assistance",
                "dataRetention": "Temporary processing only"
              },
              {
                "@type": "Thing",
                "name": "Stripe",
                "purpose": "Secure payment processing",
                "compliance": "PCI-DSS compliant"
              },
              {
                "@type": "Thing",
                "name": "Facebook Pixel",
                "purpose": "Social media advertising and tracking",
                "optOut": "https://facebook.com/settings?tab=ads"
              }
            ]
          },
          "name": "Revfer",
          "alternateName": "Revfer Inc",
          "description": "AI business discovery platform with comprehensive cookie management and user privacy controls",
          "url": "https://www.revfer.com",
          "logo": {
            "@type": "ImageObject",
            "url": "https://www.revfer.com/logo.png",
            "caption": "Revfer AI Platform Logo"
          },
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "59 Grover Rd",
            "addressLocality": "Ashland",
            "addressRegion": "MA",
            "postalCode": "01721",
            "addressCountry": "US"
          },
          "contactPoint": [
            {
              "@type": "ContactPoint",
              "contactType": "cookie support",
              "email": "cookies@revfer.com",
              "availableLanguage": "English",
              "description": "Questions about cookie usage and this policy"
            },
            {
              "@type": "ContactPoint",
              "contactType": "privacy support",
              "email": "privacy@revfer.com",
              "availableLanguage": "English", 
              "description": "Broader privacy questions and data protection concerns"
            },
            {
              "@type": "ContactPoint",
              "contactType": "technical support",
              "email": "support@revfer.com",
              "availableLanguage": "English",
              "description": "Help with cookie settings and technical issues"
            },
            {
              "@type": "ContactPoint",
              "contactType": "data protection officer",
              "email": "dpo@revfer.com",
              "availableLanguage": "English",
              "description": "Formal data protection and compliance inquiries"
            }
          ],
          "sameAs": [
            "https://twitter.com/revfer",
            "https://linkedin.com/company/revfer"
          ],
          "knowsAbout": [
            "Cookie Policy",
            "Tracking Technologies",
            "Cookie Management",
            "Privacy Controls",
            "GDPR Cookie Compliance",
            "User Consent Management", 
            "Third-Party Tracking",
            "Browser Privacy Settings",
            "Cookie Types and Duration",
            "Opt-Out Mechanisms"
          ],
          "cookiePolicy": "https://www.revfer.com/legal/cookie-policy",
          "privacyPolicy": "https://www.revfer.com/legal/privacy-policy",
          "termsOfService": "https://www.revfer.com/legal/terms-of-service",
          "cookieConsent": [
            {
              "@type": "Thing",
              "name": "Essential Cookies",
              "required": true,
              "description": "Cannot be disabled as they are critical for website functionality"
            },
            {
              "@type": "Thing", 
              "name": "Optional Cookies",
              "required": false,
              "description": "Analytics, functional, and marketing cookies that can be controlled by users"
            },
            {
              "@type": "Thing",
              "name": "Granular Controls",
              "description": "Users can control different cookie categories independently"
            },
            {
              "@type": "Thing",
              "name": "Consent Management",
              "description": "Easy-to-use interface for managing cookie preferences"
            }
          ],
          "complianceStandards": [
            {
              "@type": "Thing",
              "name": "GDPR Compliance",
              "description": "Full compliance with European Union cookie consent requirements"
            },
            {
              "@type": "Thing",
              "name": "CCPA Compliance", 
              "description": "California Consumer Privacy Act tracking technology compliance"
            },
            {
              "@type": "Thing",
              "name": "ePrivacy Directive",
              "description": "EU directive on privacy and electronic communications compliance"
            }
          ]
        }}
        faqData={{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What cookies does Revfer use and why?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Revfer uses four types of cookies: Essential cookies (required for basic functionality), Analytics cookies (to understand usage patterns), Functional cookies (to remember your preferences), and Marketing cookies (for relevant advertising). You can control all except essential cookies through your privacy settings."
              }
            },
            {
              "@type": "Question",
              "name": "How can I manage my cookie preferences on Revfer?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "You can manage cookies through Account Settings → Privacy & Data → Cookie Preferences. You can toggle different cookie categories on/off, choose granular controls, and reset non-essential cookies. You can also control cookies through your browser settings."
              }
            },
            {
              "@type": "Question",
              "name": "What happens if I disable cookies?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Essential cookies cannot be disabled as they're required for security and basic functionality. Disabling optional cookies may affect personalization, analytics, and advertising relevance, but won't prevent you from using core Revfer features."
              }
            },
            {
              "@type": "Question",
              "name": "Does Revfer use third-party cookies?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, we use third-party services like Google Analytics, OpenAI for AI processing, Stripe for payments, and social media platforms for login and sharing. These services may set their own cookies according to their privacy policies."
              }
            },
            {
              "@type": "Question",
              "name": "How long do Revfer's cookies last?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Cookie duration varies by type: Essential cookies last from session to 30 days, Analytics cookies 1 day to 2 years, Functional cookies 6 months to 1 year, and Marketing cookies 30 days to 2 years. Session cookies are deleted when you close your browser."
              }
            },
            {
              "@type": "Question",
              "name": "Is Revfer's cookie usage GDPR compliant?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, our cookie policy complies with GDPR, CCPA, and other data protection regulations. We provide clear consent mechanisms, detailed information about cookie usage, and easy controls for managing your preferences."
              }
            }
          ]
        }}
      />

      <div style={containerStyle}>
        {/* Header */}
        <div style={headerStyle}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
            <span style={{ fontSize: '40px', marginRight: '16px' }}>🍪</span>
            <h1 style={{ margin: 0, fontSize: '48px', fontWeight: '300' }}>
              Cookie Policy
            </h1>
          </div>
          <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '400', opacity: 0.9 }}>
            How we use cookies to enhance your experience and protect your privacy.
          </h2>
          <div style={{ 
            display: 'inline-block', 
            marginTop: '16px',
            padding: '8px 16px',
            backgroundColor: 'rgba(255,255,255,0.2)',
            borderRadius: '16px',
            fontSize: '14px'
          }}>
            Last Updated: June 4, 2025
          </div>
        </div>

        {/* Cookie Consent Banner Simulation */}
        <div style={{ ...paperStyle, backgroundColor: '#fff3e0', border: '2px solid #ff9800' }}>
          <h3 style={{ marginBottom: '16px', color: '#f57c00' }}>
            🍪 Cookie Preferences Demo
          </h3>
          <p style={{ marginBottom: '16px', fontSize: '14px' }}>
            This shows how cookie consent works on Revfer. You can customize your preferences for different types of cookies.
          </p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '16px' }}>
            <label style={{ display: 'flex', alignItems: 'center', fontSize: '14px', marginRight: '16px' }}>
              <input type="checkbox" checked disabled style={{ marginRight: '8px' }} />
              Essential (Required)
            </label>
            <label style={{ display: 'flex', alignItems: 'center', fontSize: '14px', marginRight: '16px' }}>
              <input type="checkbox" defaultChecked style={{ marginRight: '8px' }} />
              Analytics
            </label>
            <label style={{ display: 'flex', alignItems: 'center', fontSize: '14px', marginRight: '16px' }}>
              <input type="checkbox" defaultChecked style={{ marginRight: '8px' }} />
              Functional
            </label>
            <label style={{ display: 'flex', alignItems: 'center', fontSize: '14px', marginRight: '16px' }}>
              <input type="checkbox" style={{ marginRight: '8px' }} />
              Marketing
            </label>
          </div>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button style={primaryButtonStyle}>Accept Selected</button>
            <button style={outlinedButtonStyle}>Accept All</button>
            <button style={outlinedButtonStyle}>Reject Optional</button>
          </div>
        </div>

        {/* Quick Navigation */}
        <div style={paperStyle}>
          <h3 style={{ marginBottom: '16px', color: '#ff9800' }}>
            Quick Navigation
          </h3>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {sections.map((section) => (
              <span
                key={section.id}
                style={{
                  ...chipStyle,
                  backgroundColor: expandedSection === section.id ? section.color : '#f5f5f5',
                  color: expandedSection === section.id ? 'white' : '#666',
                  border: expandedSection === section.id ? 'none' : '1px solid #e0e0e0'
                }}
                onClick={() => setExpandedSection(section.id)}
              >
                {section.icon} {section.title}
              </span>
            ))}
          </div>
        </div>

        {/* Main Content */}
        <div>
          {sections.map((section) => (
            <div key={section.id} style={accordionStyle}>
              <div
                style={{
                  ...accordionHeaderStyle,
                  backgroundColor: expandedSection === section.id ? '#f5f5f5' : '#fafafa'
                }}
                onClick={() => handleAccordionToggle(section.id)}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span style={{ fontSize: '24px', marginRight: '12px', color: section.color }}>
                    {section.icon}
                  </span>
                  <h3 style={{ margin: 0, fontSize: '20px' }}>
                    {section.title}
                  </h3>
                </div>
                <span style={{ fontSize: '20px', color: '#666' }}>
                  {expandedSection === section.id ? '−' : '+'}
                </span>
              </div>
              {expandedSection === section.id && (
                <div style={accordionContentStyle}>
                  {section.content}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Footer Actions */}
        {showSection &&
        <div style={{ ...paperStyle, backgroundColor: '#f5f5f5', marginTop: '32px' }}>
        <h3 style={{ marginBottom: '16px', color: '#ff9800' }}>
          Manage Your Cookie Preferences
        </h3>
        <p style={{ marginBottom: '16px' }}>
          Take control of your privacy by customizing how cookies are used during your Revfer experience.
        </p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
          <button 
            style={primaryButtonStyle}
            onClick={() => alert('Cookie settings would open here in the actual app')}
          >
            Cookie Settings
          </button>
          <button 
            style={outlinedButtonStyle}
            onClick={() => window.open('/legal/privacy-policy', '_blank')}
          >
            View Privacy Policy
          </button>
          <button 
            style={outlinedButtonStyle}
            onClick={() => window.location.href = 'mailto:cookies@revfer.com?subject=Cookie Policy Question'}
          >
            Contact Privacy Team
          </button>
        </div>
      </div>
        
        }
        
      </div>
    </>
  );
};

export default CookiePolicyPage;